"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomPlayerJoinMessage = void 0;
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../../message");
exports.RoomPlayerJoinMessage = message_1.createMessage('room/player/join', joi_1.default.object({
    roomId: joi_1.default.string().required()
}))
    .withResponse();
